<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            @click="(showCouleurstrafe = true) && (neuCouleurstrafe = true) && (couleurstrafe = couleurstrafeVorlage)"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Erstellen</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>save_alt</v-icon></v-btn>
        </template>
        <span>Exportieren</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>delete</v-icon></v-btn>
        </template>
        <span>Löschen</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row class="ma-0">
      <v-col cols="12" lg="10" offset-lg="1">
        <v-card outlined>
          <v-data-table
            dense
            :height="sideHeight"
            :headers="headers"
            :items="couleurstrafen"
            :search="search"
            fixed-header
            hide-default-footer
            :items-per-page="-1"
            :hide-default-header="$vuetify.breakpoint.xsOnly"
            no-data-text="Keine Couleurstrafen eingetragen"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ $filters.date(item.datum, "DD.MM.YYYY") }}</td>
                <td>{{ item.titel }}</td>
                <td v-if="item.strafen">{{ item.strafen.length }} Strafen</td>
                <td v-else>Keine Strafen</td>
                <td>
                  <v-btn
                    icon
                    @click="(couleurstrafe = item) && (showCouleurstrafe = true) && (neuCouleurstrafe = false)"
                    ><v-icon>edit</v-icon></v-btn
                  >
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <v-divider></v-divider>
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <div class="subtitle-2 mt-2 mb-2 mr-6">Summe offene Strafen: {{ summe | money }}</div>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showCouleurstrafe" :fullscreen="$vuetify.breakpoint.smAndDown" width="50%" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-card-title>
          <div v-if="neuCouleurstrafe" class="pr-1">Neue Couleurstrafe erstellen</div>
          {{ couleurstrafe.titel }} - {{ $filters.date(couleurstrafe.datum, "DD.MM.YYYY") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showCouleurstrafe = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="6">
              <v-text-field dense hide-details outlined v-model="couleurstrafe.titel" label="Titel"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menu"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    v-model="formatDatum"
                    label="Datum"
                    readonly
                    locale="de-de"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  prev-icon="keyboard_arrow_left"
                  next-icon="keyboard_arrow_right"
                  v-model="couleurstrafe.datum"
                  locale="de-de"
                  first-day-of-week="1"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                dense
                hide-details
                outlined
                v-model="newEintragCouleurstrafe.wer"
                :items="selectBbrbbr"
                label="Wer"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-text-field
                dense
                hide-details
                outlined
                v-model="newEintragCouleurstrafe.betrag"
                label="Betrag"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn icon @click="addEintragCouleurstrafe()"><v-icon>add</v-icon></v-btn>
            </v-col>
            <v-col cols="12">
              <v-card outlined>
                <v-simple-table fixed-header dense class="mb-0">
                  <tbody v-if="couleurstrafe.strafen">
                    <tr v-for="(item, index) in couleurstrafe.strafen" :key="index">
                      <td width="20px">{{ index + 1 }}</td>
                      <td>{{ $filters.user(item.wer, bbrbbr) }}</td>
                      <td class="text-right">{{ item.betrag | money }}</td>
                      <td class="text-right">
                        <v-label chip color="green" v-if="item.bezahlt">Bezahlt</v-label>
                      </td>
                      <td width="20px">
                        <v-btn icon @click="deleteEintragCouleurstrafe(index)"><v-icon>delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn icon v-if="!neuCouleurstrafe" @click="showDeleteCouleurstrafe = true" v-on="on"
            ><v-icon>delete</v-icon></v-btn
          >
          <v-btn v-if="neuCouleurstrafe" text @click="showCouleurstrafe = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="neuCouleurstrafe"
            :disabled="couleurstrafe.strafen.length === 0"
            :class="couleurstrafe.strafen.length > 0 ? 'primary' : ''"
            text
            @click="createCouleurstrafe()"
            >Speichern</v-btn
          >
          <v-btn
            v-else
            :disabled="couleurstrafe.strafen.length === 0"
            :class="couleurstrafe.strafen.length > 0 ? 'primary' : ''"
            @click="updateCouleurstrafe()"
            text
            >Speichern</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogDelete
      :visible.sync="showDeleteCouleurstrafe"
      title="Eintrag löschen"
      message="Willst du diesen Eintrag wirklich löschen?"
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteCouleurstrafe()"
      @closeFalse="showDeleteCouleurstrafe = false"
    >
    </dialogDelete>
  </v-container>
</template>

<script>
  export default {
    props: ["on"],
    data() {
      return {
        headers: [
          { text: "Datum", value: "datum" },
          { text: "Titel", value: "titel" },
          { text: "Anzahl", value: "strafen.length" },
          { text: "", value: "" },
        ],
        selected: [],
        search: "",
        menu1: "",
        showCouleurstrafe: false,
        couleurstrafe: {
          datum: "",
          titel: "",
          strafen: [],
        },
        neuCouleurstrafe: false,
        newEintragCouleurstrafe: {},
        showDeleteCouleurstrafe: false,
        couleurstrafeVorlage: {
          datum: "",
          titel: "",
          strafen: [],
        },
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      formatDatum() {
        if (!this.couleurstrafe.datum) return null;
        return new Date(this.couleurstrafe.datum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      sideHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 239px)";
          case "sm":
            return "calc(100vh - 239px)";
          case "md":
            return "calc(100vh - 239px)";
          case "lg":
            return "calc(100vh - 239px)";
          case "xl":
            return "calc(100vh - 239px)";
        }
      },
      selectBbrbbr() {
        let selectBbrbbr = [];
        this.$store.getters["bbrbbr/nurBbrbbr"].forEach((bbr) => {
          selectBbrbbr.push({
            id: bbr.id,
            value: bbr.id,
            name: bbr.nachname + ", " + bbr.vorname,
            text: bbr.nachname + ", " + bbr.vorname,
          });
        });
        return selectBbrbbr;
      },
      couleurstrafen() {
        if (this.$store.state.couleurstrafen.couleurstrafen.length === 0) {
          this.$store.dispatch("couleurstrafen/loadCouleurstrafen");
        }

        return this.$store.state.couleurstrafen.couleurstrafen.sort((a, b) => {
          // Umkehrung der Reihenfolge, falls notwendig (absteigend)
          if (a.datum < b.datum) return 1;
          if (a.datum > b.datum) return -1;
          return 0;
        });
      },
      summe() {
        let summe = 0;
        if (this.couleurstrafen) {
          this.couleurstrafen.forEach((item) => {
            if (item.strafen) {
              item.strafen.forEach((strafe) => {
                if (!strafe.bezahlt) {
                  summe += parseFloat(strafe.betrag);
                }
              });
            }
          });
        }
        return summe;
      },
    },
    methods: {
      addEintragCouleurstrafe() {
        if (this.newEintragCouleurstrafe.wer && this.newEintragCouleurstrafe.betrag > 0) {
          if (!this.couleurstrafe.strafen) {
            this.couleurstrafe.strafen = [];
          }
          this.couleurstrafe.strafen.push({
            id: new Date().getTime(),
            wer: this.newEintragCouleurstrafe.wer,
            betrag: this.newEintragCouleurstrafe.betrag,
            bezahlt: false,
          });
          this.newEintragCouleurstrafe = {};
        }
      },
      deleteEintragCouleurstrafe(index) {
        this.couleurstrafe.strafen.splice(index, 1);
      },
      createCouleurstrafe() {
        console.log(this.couleurstrafe);
        this.$store.dispatch("couleurstrafen/createCouleurstraf", this.couleurstrafe);
        this.showCouleurstrafe = false;
        this.couleurstrafe = this.couleurstrafeVorlage;
      },
      updateCouleurstrafe() {
        this.$store.dispatch("couleurstrafen/updateCouleurstrafData", this.couleurstrafe);
        this.showCouleurstrafe = false;
        this.couleurstrafe = this.couleurstrafeVorlage;
      },
      deleteCouleurstrafe() {
        this.$store.dispatch("couleurstrafen/deleteCouleurstrafData", this.couleurstrafe.id);
        this.showCouleurstrafe = false;
        this.couleurstrafe = this.couleurstrafeVorlage;
        this.showDeleteCouleurstrafe = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// couleurstrafen.vue?d55bba4e